import { state } from "@/store/Modules/Offer/state";
import { createI18n } from "vue-i18n";
import { LanguageType } from "./languageTypes";
import dk from "./translations/da-DK.json";
import en from "./translations/en-US.json";
import de from "./translations/de-DE.json";

export const languageOptions = {
  [LanguageType.DK]: dk,
  [LanguageType.EN]: en,
  [LanguageType.DE]: de,
}

export const i18n = createI18n({
  locale: state.Language,
  messages: languageOptions
})

export const allLanguages = [
  {value: LanguageType.DK, caption: "Dansk"},
  {value: LanguageType.EN, caption: "English"},
  {value: LanguageType.DE, caption: "Deutsch"},
]